<template>
    <div class="table-wrap">
      <h4>Nova Categoria</h4>
      <Formulario></Formulario>
      <div class="botao">

      </div>
      </div>
      

</template>

<script>
 import Formulario from '@/components/financeiro/vouchers/form/Formulario.vue'

export default {
  components: { Formulario },

    data() {
    return {
        tiposVoucher: [], 
        voucher: null
    };
  },
}
</script>

<style lang="scss" scoped>

.table-wrap {
    padding: $hmg $hmg_small $mg_extra;
  }
  .btn {
    margin-left: $mg_mini;
    margin-top: $hmg_mid;
  }
</style>>

